import { ApiEndpoints } from '../../constants/ApiEndpoints';
import { baseRequest } from '../../utils/HttpClient';

export const getTwilioToken = requestBody => {
  return baseRequest(ApiEndpoints.GET_TWILIO_TOKEN, requestBody, null);
};
